/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Quicktools_VoicesInputs */



/**
* | output |
* | --- |
* | "Voices" |
*
* @param {Options_Quicktools_VoicesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_quicktools_voices = /** @type {((inputs?: Options_Quicktools_VoicesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Quicktools_VoicesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voix")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stimmen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Voci")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Голоса")
	if (locale === "es") return /** @type {LocalizedString} */ ("Voces")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("声音")
	if (locale === "ja") return /** @type {LocalizedString} */ ("声")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आवाज़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Vozes")
	return /** @type {LocalizedString} */ ("Voices")
});